<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <router-link tag="button" :to="{name: 'groups.create'}" class="btn btn-info">
                    <span class="btn-label">
                        <i class="material-icons">add</i>
                    </span>
                    Novo
                </router-link>
            </div>
        </div>
        <FiltersSearch @filterName='filterName'
                         @resetFilters='resetFilters'
                         @filterAdministrator='filterAdministrator' />
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card-header-icon card-header-rose">
                        <div class="card-icon">
                            <i class="material-icons">list</i>
                        </div>
                        <h4 class="card-title ">Lista</h4>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th class="text-center">#</th>
                                        <th>Nome</th>
                                        <th>Cotas</th>
                                        <th>Assembĺéia</th>
                                        <th>Administradora</th>
                                        <th>Prazo</th>
                                        <th class="text-right">Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-show="items.length > 0"
                                        v-for="iterator in items"
                                        :key="iterator.id">
                                        <td class="text-center">{{ iterator.id }}</td>
                                        <td v-html="formatTextSearch(iterator.name)"></td>
                                        <td v-html="formatTextSearch(iterator.quotas)"></td>
                                        <td v-html="formatTextSearch(iterator.meeting_at_masked)"></td>
                                        <td v-html="formatTextSearch(iterator.administrator.name)"></td>
                                        <td>{{ iterator.deadline }}</td>
                                        <td class="td-actions text-right">
                                <index-buttons
                                    :iterator=iterator
                                    :showAudit="false"
                                    :toAudit="{name: 'groups'}"
                                    :showEdit="true"
                                    :toEdit="{name: 'groups.edit', params: { id: iterator.id }}"
                                    :showRemove="true"
                                    dispatchRemove="groups/rem"
                                    :callbackRemove="_refredData"
                                    >
                            </index-buttons>
                            </td>
                            </tr>
                            <tr v-show="items.length==0">
                                <td colspan="6">Nenhum grupo encontrado!</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
    import FiltersSearch from './Filters';
    export default {
        components : { FiltersSearch },
        computed: {
            _items: {
                set(_groups) {
                    this.$store.commit('groups/setList', _groups);
                },
                get() {
                    return this.$store.state.groups.itens;
                }
            }
        },
        created: function () {
            this._refredData();
        },
        data() {
            return {
                currentPage: 1,
                textSearch : '',
                items : []
            };
        },
        methods: {
            formatTextSearch(name){
                name = String(name);
                let re = new RegExp( '('+this.textSearch+')', 'gi' );
                return name.replace(re, '<b><u>$1</u></b>')
            },
            filterName( name ){
                this.textSearch = name;
                var re = new RegExp( name, 'gi' );
                this.items = this._items.filter( item => ((item.name.toLowerCase().indexOf(name.toLowerCase()) > -1) || re.test( item.quotas ) || re.test( item.meeting_at_masked ) || re.test((item.administrator ? item.administrator.name : ''))) );
                // this.items = this._items.filter( item => item.name.toLowerCase().indexOf(name.toLowerCase()) > -1  );
            },
            filterAdministrator( id ){
                this.items = this._items.filter(item => item.administrator_id == id)
            },
            resetFilters(){
                this.items = this._items;
                this.textSearch = '';
            },
            _refredData() {
                this.getData();
                setTimeout(() => this.items = this._items, 1000);
            },
            async getData() {
                var self = this;

                self.$root.$emit('onLoading');
                const response = self.$store.dispatch('groups/all');

                response.then(function () {
                    self.$root.$emit('onLoading');
                });

                response.catch(function () {
                    self.$root.$emit('onLoading');
                });
            }
        }
    }
</script>